export default function KeyDifferentiators() {
  const differentiators = [
    {
      icon: 'ri-shield-cross-line',
      title: 'Thorough Upfront Inspection',
      description: 'We inspect every vehicle before you buy — so you know exactly what you\'re getting. No surprises, no regrets. No "as-is" fine print that means "good luck."',
    },
    {
      icon: 'ri-truck-line',
      title: 'Delivery Often Included',
      description: 'Delivery cost is frequently rolled into financing or the purchase price. No surprise "transport fee" showing up at the end. No "destination charge" that was always going to be there.',
    },
    {
      icon: 'ri-map-pin-range-line',
      title: 'Any Vehicle, Any State',
      description: 'We\'re not limited to one lot or one region. Dealers, auctions, private sellers — if it exists in the US, we can find it. You\'re not stuck with "what we have in stock right now."',
    },
    {
      icon: 'ri-bank-card-line',
      title: 'All Credit Types Welcome',
      description: 'Excellent, good, fair, or rebuilding — we work with multiple lenders to get you approved. Your credit score isn\'t the final word. And we\'re not marking up your rate to pay for the finance manager\'s vacation.',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Flat $995 Broker Fee',
      description: 'No percentage markups. No mystery charges. One flat fee covers sourcing, negotiation, inspection, and delivery coordination. Not $895. Not "market rate." $995. That\'s it.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'We Work for You',
      description: 'Our brokers are on your side — not the dealer\'s. We negotiate hard, inspect thoroughly, and don\'t move without your approval. We\'re not on commission. Wild concept, we know.',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#E8B84B]/15 border border-[#E8B84B]/40 rounded-full px-4 py-2 mb-4">
            <i className="ri-star-line text-[#E8B84B]"></i>
            <span className="text-sm font-semibold text-[#1A2332]">What Sets Us Apart</span>
          </div>
          <h2 className="font-['Oswald'] text-4xl md:text-5xl font-bold text-[#1A2332] mb-4">
            Six Reasons We're Different
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            We're not a dealership. We're an auto broker. Here's what that means for you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {differentiators.map((item) => (
            <div
              key={item.title}
              className="bg-[#F7F5F0] p-8 rounded-2xl border border-[#E8E2D6] hover:border-[#E8B84B]/50 hover:shadow-md transition-all group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#E8B84B]/15 rounded-xl mb-5 group-hover:bg-[#E8B84B]/25 transition-colors" aria-hidden="true">
                <i className={`${item.icon} text-[#E8B84B] text-2xl`}></i>
              </div>
              <h3 className="font-['Oswald'] text-xl font-bold text-[#1A2332] mb-3">{item.title}</h3>
              <p className="text-gray-700">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}